import { mapDTO } from '@twistezo/ts-dto-mapper'

import { GamOrderRetargetingDealsDeliverySlice } from '../types'
import { GamOrderRetargetingDealsDeliverySliceDTO } from './types'

type From = GamOrderRetargetingDealsDeliverySliceDTO
type To = GamOrderRetargetingDealsDeliverySlice

export const fromDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform(
    (dto: From): To => ({
      currency: dto.currency || undefined,
      errorMessage: dto.errorMessage || undefined,
      geo: dto.geo ?? '',
      proposalId: dto.proposalId?.toString() ?? '',
      status: dto.status,
    }),
  )
